var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "21px",
    viewBox: "0 0 19 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "shield-alt") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sys-Admin---Parking-zones---Create-Parking-zone-3",
    transform: "translate(-31.000000, -272.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Left-menu---Sys-admin---PZ",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.1285712,292.343744 C41.4306512,291.822913 42.6806482,290.97656 43.8785622,289.804688 C45.3108507,288.398441 46.4566811,286.75782 47.316054,284.882825 C48.3056348,282.643247 48.8004255,280.182315 48.8004255,277.50003 C48.8004255,277.109406 48.6962589,276.757844 48.4879262,276.445345 C48.2795936,276.132846 47.9931356,275.911492 47.6285533,275.781284 L40.1285712,272.656291 C39.6598223,272.447959 39.1910734,272.447959 38.7223245,272.656291 L31.2223424,275.781284 C30.8577601,275.911492 30.5713021,276.132846 30.3629695,276.445345 C30.1546368,276.757844 30.0504702,277.109406 30.0504702,277.50003 C30.0504702,279.947941 30.4931773,282.252623 31.378592,284.414076 C32.1598402,286.341154 33.240567,288.020838 34.6207718,289.453126 C35.8707688,290.781248 37.2379531,291.744788 38.7223245,292.343744 C39.1910734,292.552077 39.6598223,292.552077 40.1285712,292.343744 Z M39.4254479,290.624999 C38.1233678,290.078125 36.9124332,289.19271 35.792644,287.968755 C34.6207718,286.692716 33.6962947,285.195324 33.0192131,283.476578 C32.290048,281.601583 31.9254657,279.6094 31.9254657,277.50003 L39.4254479,274.375037 L46.92543,277.50003 C46.92543,279.661483 46.5478265,281.692728 45.7926202,283.593765 C45.1155387,285.286469 44.1780409,286.770841 42.9801269,288.04688 C41.8863795,289.244794 40.7014867,290.104167 39.4254479,290.624999 Z M39.4254479,288.515629 L39.4254479,276.406282 L33.8395237,278.750027 C33.9957733,280.937522 34.59473,282.890642 35.6363944,284.609388 C36.599934,286.250009 37.8629516,287.552089 39.4254479,288.515629 Z",
    id: "shield-alt"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldAlt);
export default __webpack_public_path__ + "static/media/shield-alt.23d1924e6363c32c601f74662469c74a.svg";
export { ForwardRef as ReactComponent };